import React, { useState } from "react";
import Select from "react-select";
import moment from "moment";
import { Form, useNavigate } from "react-router-dom";
import { TypeOfApplicationEnum } from "../../utils/enum";
import { Button, Modal, Spinner } from "react-bootstrap";
import { savehardCopyDetails } from "../../api/apimethods";
import { NotifyType } from "../../utils/NotifyType";
import { ErrMsg } from "../../utils/app-config";
import { notify } from "../../utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";

export const dashboardNavConfig: any = {
  AQU: "aqua-samples-and-tests",
  COM: "samples-and-tests",
  BIO: "bio-samples-and-tests",
  TER: "ter-samples-and-tests",
  ENV: "env-samples-and-tests",
  AVI: "avi-samples-and-tests",
  FRW: "frw-samples-and-tests",
};

interface LabGridRowProps {
  data: any;
  subRows: any[];
  isExpanded: boolean;
  showAmendmentButton: boolean;
  showDuplicateButton: boolean;
  showCancelButton: boolean;
  sno: number;
}
interface ReportCopies {
  [report: string]: number;
}
const LabGridRow: React.FC<LabGridRowProps> = ({
  data,
  subRows,
  isExpanded,
  showAmendmentButton,
  showDuplicateButton,
  showCancelButton,
  sno,
}) => {
  const navigate = useNavigate();
  const { message } = notify();
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [selectedOptions, setSelectedOptions] = useState(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [reportCopies, setReportCopies] = useState<ReportCopies>({});
  const [selectedReports, setSelectedReports] = useState<string[]>([]);
  const handleReportChange = (selectedOptions: any) => {
    const selected = selectedOptions
      ? selectedOptions.map((opt: any) => opt.value)
      : [];

    setSelectedReports(selected);
    const updatedCopies: ReportCopies = {};
    selected.forEach((report: string) => {
      updatedCopies[report] = reportCopies[report] || 1;
    });
    setReportCopies(updatedCopies);
    setErrorMessage(null);
  };

  const handleCopiesChange = (report: any, value: any) => {
    setReportCopies((prev) => ({
      ...prev,
      [report]: Math.min(Math.max(value, 1), 999),
    }));
  };
  const navToSamples = (
    appNum: string,
    typeOfApp: string,
    purposeCode?: string
  ) => {
    if (!purposeCode) {
      message(NotifyType.Error, "Purpose code is Empty");
      return;
    }

    navigate(
      `/${dashboardNavConfig[purposeCode]}?an=${appNum}&type=${typeOfApp}`
    );
  };

  const toggleExpandRow = (appNum: string) => {
    setExpandedRows((prevState) => ({
      ...prevState,
      [appNum]: !prevState[appNum],
    }));
  };
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };
  const handleDuplicateClick = () => {
    setShowDuplicateModal(true);
  };

  const handleConfirmDuplicate = async () => {
    if (!selectedReports || selectedReports.length === 0) {
      setErrorMessage("Please select at least one report.");
      return;
    }
    setErrorMessage("");
    const hardCopyDetails = selectedReports.reduce((acc, report) => {
      acc[report] = reportCopies[report] || 1;
      return acc;
    }, {} as Record<string, number>);
    const reportNameAndCopiesArray = selectedReports.map((report) => ({
      reportName: report,
      hardCopies: reportCopies[report] || 1,
    }));
    const hardCopyApplicationStatus = {
      applicationRequestFor: 2,
      miiApplication: 31,
      eserviceApplication: 21,
      islabapplicationDuplicated: 1,
      actionRequest: "Duplicate request",
    };
    const hardCopyDetail = {
      applicationNumber: data.applicationNumber,
      requestorName: data.requestorName,
      applicationDate: data.applicationDate,
      sampleDate: data.sampleDate,
      applicationStatus: data.applicationStatus,
      purposeCode: data.purposeCode,
      hardCopy: data.hardCopy,
      hardCopyDetails: hardCopyDetails,
      reportNameAndCopies: reportNameAndCopiesArray,
    };
    const getUserInfo = localStorage.getItem("app-data");
    const userInfo = JSON.parse(getUserInfo || "{}");
    const Nric = userInfo?.user?.idNo || "";
    const combinedData = {
      Nric,
      hardCopyApplicationStatus,

      hardCopyDetail,
    };

    try {
      handleLoader(true, "submit-reqq");

      const response = await savehardCopyDetails(combinedData);

      if (response?.status === 200) {
        const responseData = JSON.parse(response.data as any);
        const hardCopyApplicationNumber =
          responseData?.HardCopyApplicationNumber;
        if (hardCopyApplicationNumber) {
          message(
            NotifyType.Success,
            ` Request Saved Successfully. Application Number: ${hardCopyApplicationNumber}`
          );
          setAcknowledgmentMessage(`${hardCopyApplicationNumber}`);
          setExpandedRows({});
          setSelectedOptions(null);
          setSelectedReports([]);
          setReportCopies({});
        } else {
          message(NotifyType.Error, "HardCopy Application Number not found");
        }
      } else {
        message(NotifyType.Error, "Bad request");
      }
    } catch (error) {
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    } finally {
      handleLoader(false, "submit-reqq");
      setShowDuplicateModal(false);
    }
  };

  const handleCancelDuplicate = () => {
    setShowDuplicateModal(false);
  };
  return (
    <>
      {acknowledgmentMessage && (
        <div className="info-content attentionpopupmodal">
          <div className="att">
            <h3>Attention</h3>
            <button
              onClick={() => setAcknowledgmentMessage(null)}
              className="attentionpopup"
            >
              &#10005;
            </button>
            <br />
            <p className="attention">
              {">"} Application has been successfully Saved. Service
              Acknowledgement Number: &nbsp;
              {acknowledgmentMessage ? acknowledgmentMessage : ""}
            </p>
          </div>
        </div>
      )}

      <>
        <tr>
          {/* <td>{sno}</td>
        <td>
          {subRows.length > 0 && (
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                toggleExpandRow(data.applicationNumber);
              }}
            >
              {isExpanded ? "[-]" : "[+]"}
            </a>
          )}
        </td> */}
          <td>{data.purposeCode || ""}</td>

          <td>
            <a
              href="#"
              onClick={(e) => {
                if (data.applicationStatus?.startsWith("Duplicate Hard Copy")) {
                  e.preventDefault();
                  return;
                }
                e.preventDefault();
                navToSamples(
                  data.applicationNumber,
                  TypeOfApplicationEnum.acknowledgement,
                  data.purposeCode
                );
              }}
              className={`linked ${
                data.applicationStatus?.startsWith("Duplicate Hard Copy")
                  ? "disabled"
                  : ""
              }`}
            >
              {data.applicationNumber || ""}
            </a>
          </td>
          <td>{data.applicationId || ""}</td>
          <td>{data.requestorName || ""}</td>
          <td>
            {data.applicationDate
              ? moment(data.applicationDate).format("DD/MM/yyyy")
              : ""}
          </td>
          <td>
            {data.sampleDate
              ? moment(data.sampleDate).format("DD/MM/yyyy")
              : ""}
          </td>
          <td>{data.applicationStatus || ""}</td>
          <td>
            {data.showAmendButton === 1 && (
              <>
                {
                  <button
                    onClick={() =>
                      navToSamples(
                        data.applicationNumber,
                        TypeOfApplicationEnum.amendment,
                        data.purposeCode
                      )
                    }
                    type="button"
                    className="amendment"
                  >
                    Amendment
                  </button>
                }
                <br />
              </>
            )}

            {/* {data.showCancelButton === 1 && (
              <button
                onClick={() =>
                  navToSamples(
                    data.applicationNumber,
                    TypeOfApplicationEnum.cancel,
                    data.purposeCode
                  )
                }
                type="button"
                className="amendment"
              >
                Cancel
              </button>
            )} */}

            {showDuplicateButton && data.showDuplicateHardCopyButton === 1 && (
              <button
                onClick={handleDuplicateClick}
                type="button"
                className="amendment"
              >
                Duplicate
              </button>
            )}
          </td>
        </tr>
      </>

      {isExpanded && subRows.length > 0 && (
        <tr>
          <td colSpan={8}>
            <div className="sub-grid-container">
              <table className="sub-grid">
                <thead>
                  <tr>
                    {" "}
                    <th className="amed" colSpan={7}>
                      Amend/Cancel Application(s)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {subRows.map((subRow: any, subIndex: any) => (
                    <tr key={`${subRow.applicationNumber}-${subIndex}`}>
                      <td>
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            navToSamples(
                              subRow.applicationNumber,
                              TypeOfApplicationEnum.acknowledgement,
                              subRow.purposeCode
                            );
                          }}
                        >
                          {subRow.applicationNumber || ""}
                        </a>
                      </td>
                      <td>{subRow.applicationId || ""}</td>
                      <td>{subRow.requestorName || ""}</td>
                      <td>
                        {subRow.applicationDate
                          ? moment(subRow.applicationDate).format("DD/MM/yyyy")
                          : ""}
                      </td>
                      <td>
                        {subRow.sampleDate
                          ? moment(subRow.sampleDate).format("DD/MM/yyyy")
                          : ""}
                      </td>
                      <td>{subRow.applicationStatus || ""}</td>
                      <td></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      )}
      <Modal
        show={showDuplicateModal}
        className="popup-3"
        onHide={handleCancelDuplicate}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Duplicate Request</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You are applying for Duplicate Hard Copy of Lab Reports.</p>
          <p>Each duplicate hardcopy will charged 9.45 SGD.</p>
          <div className="row mt-2 mt-lg-0">
            <div className="col-lg-12">
              <label htmlFor="Reportname">
                Select Lab Report for Hard Copy
                <span className="star-red">*</span>
              </label>
            </div>
          </div>

          <div className="row mt-2 mt-lg-0">
            <div className="col-lg-12">
              <Select
                isMulti
                name="reportname"
                options={
                  data.reportNames?.map((reportName: any) => ({
                    value: reportName,
                    label: reportName,
                  })) || []
                }
                className="basic-multi-select"
                classNamePrefix="select"
                onChange={handleReportChange}
              />
              {errorMessage && (
                <div className="error-message">
                  <FontAwesomeIcon
                    className="me-1"
                    icon={faCircleExclamation}
                  />
                  {errorMessage}
                </div>
              )}
            </div>
          </div>

          {selectedReports.map((report) => (
            <div className="row mt-2" key={report}>
              <div className="col-lg-12">
                <label>
                  No. of Hard Copies needed for {report} Report
                  <span className="star-red">*</span>
                </label>
                <input
                  type="number"
                  id={`hardCopies-${report}`}
                  name={`hardCopies-${report}`}
                  min="1"
                  max="999"
                  value={reportCopies[report] || 1}
                  onChange={(e) =>
                    handleCopiesChange(report, Number(e.target.value))
                  }
                  className="form-control"
                />
                {reportCopies[report] < 1 && (
                  <div className="error-message">
                    <FontAwesomeIcon
                      className="me-1"
                      icon={faCircleExclamation}
                    />
                    Please enter at least 1 hard copy.
                  </div>
                )}
              </div>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDuplicate}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmDuplicate}>
            Confirm
            {btnNameForLoader == "submit-reqq" ? (
              <Spinner
                className="btn-spinner"
                animation="border"
                variant="light"
              />
            ) : (
              ""
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LabGridRow;
